import { InsightsGridModel } from '@_types/organisms';
import { getModifiers } from '@helpers/functions';
import Carousel from '@organisms/carousel/Carousel';
import ReadMore from '@organisms/read-more/ReadMore';

import InsightItem from './InsightItem';

const InsightsGrid = (model: InsightsGridModel) => {
  const styleModifiers = getModifiers(model, 'kf-o-insights-grid');
  const { list, carousel, readMore } = model;

  return (
    <div className={styleModifiers}>
      {!carousel && (
        <div className="kf-container">
          {readMore ? (
            <ReadMore contentClass="kf-o-insights-grid__grid" {...readMore}>
              <>
                {list?.items?.map((item, index) => (
                  <InsightItem key={index} {...item.insight} dataSet={{ inert: true }} />
                ))}
              </>
            </ReadMore>
          ) : (
            <div className="kf-o-insights-grid__grid">
              {list?.items?.map((item, index) => (
                <InsightItem key={index} {...item.insight} />
              ))}
            </div>
          )}
        </div>
      )}

      {carousel && (
        <div className="kf-o-insights-grid__carousel">
          <Carousel {...list} />
        </div>
      )}
    </div>
  );
};

export default InsightsGrid;
